<script>
import { isNil } from 'lodash';
import MapAPI from '@/api/topologymap/common';
import WObjtypeBar from '@/views/performance/group/components/ObjtypeBar';

export default {
  name: 'WTopologymapObjtypeBar',
  extends: WObjtypeBar,
  props: {
    active: {
      type: Boolean,
      defulat: () => false,
    },
  },
  data() {
    return {
      objDefineList: [],
    };
  },
  methods: {
    loadData() {
      if (this.active) {
        const params = {
          mapId: this.$store.getters.getCurrentMapId,
        };
        MapAPI.getObjCountForObjdefine(params).then((response) => {
          if (response.data.success) {
            const tempList = response.data.data;
            tempList.forEach((items) => {
              if (!isNil(this.selectedObjDefineIds) && this.selectedObjDefineIds.indexOf(items.objDefineId) > -1) {
                items.isActive = true;
              } else {
                items.isActive = false;
              }
            });
            this.objDefineList = tempList;
          }
        });
      }
    },
    close() {
      this.objDefineList = [];
      this.$store.dispatch('setObjDefineIds', []);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/topologymap/components/perfoper/TopologymapObjtypeBar.vue